import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"; // Import useParams hook
import { db } from "../firebase"; // Firebase configuration
import { doc, getDoc, collection, getDocs } from "firebase/firestore"; // Firestore functions
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Add toast styles
import trainer from "../assets/trainer.png"; // Assuming you have this asset for the logo
import bismillah from "../assets/bismillah.png";
import logo from "../assets/logo.png";

const ViewTrainingResults = () => {
  const { userId, quizId } = useParams(); // Retrieve userId and quizId from URL
  const [quizData, setQuizData] = useState(null);
  const [userDetails, setUserDetails] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [trainingName, setTrainingName] = useState("");
  const [trainingType, setTrainingType] = useState("");

  useEffect(() => {
    const fetchQuizData = async () => {
      setLoading(true);
      try {
        // Fetch the User's Details based on the userId
        const userDocRef = doc(db, "users", userId);
        const userDocSnap = await getDoc(userDocRef);
        if (userDocSnap.exists()) {
          setUserDetails(userDocSnap.data());
        } else {
          toast.error("User not found!");
        }

        // Fetch the Quiz Data based on the quizId for this user
        const quizDocRef = doc(db, "users", userId, "quizzes", quizId);
        const quizDocSnap = await getDoc(quizDocRef);
        if (quizDocSnap.exists()) {
          setQuizData(quizDocSnap.data());
        } else {
          toast.error("Quiz not found!");
        }

        
        
  
        // Fetch all the questions for the given quizId (assuming they are in the 'trainings/{quizId}/questions' collection)
        const questionsQuerySnapshot = await getDocs(
          collection(db, `trainings/${quizId}/questions`)
        );
        const questionsData = questionsQuerySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setQuestions(questionsData);
      } catch (error) {
        toast.error("Error fetching data: " + error.message);
      } finally {
        setLoading(false);
      }
    };

    const fetchTrainingDetails = async () => {
      try {
        const trainingDoc = await getDoc(doc(db, "trainings", quizId));
        if (trainingDoc.exists()) {
          setTrainingName(trainingDoc.data().name);
          setTrainingType(trainingDoc.data().type); // Fetch training type (true_false or mcq)
        } else {
          toast.error("Training not found!");
        }
      } catch (error) {
        toast.error("Error fetching training details: " + error.message);
      }
    };


    

    


    fetchQuizData();
    fetchTrainingDetails();
    
  }, [userId, quizId]);

  // Show loading spinner while fetching data
  if (loading) {
    return (
      <div className="container mt-3">
        <div className="text-center">
          <img className="logo-img" src={trainer} alt="Bee's Care Ltd" />
          <h2>Loading Training Results...</h2>
        </div>
      </div>
    );
  }

  const formatDate = (dateString) => {
    if (!dateString) return ''; // Handle empty or undefined date
    const date = new Date(dateString);  // Convert string to Date object

    const day = String(date.getDate()).padStart(2, '0');  // Get day and ensure 2 digits
    const month = String(date.getMonth() + 1).padStart(2, '0');  // Get month (0-based, so add 1) and ensure 2 digits
    const year = date.getFullYear();  // Get year

    return `${day}/${month}/${year}`;  // Return formatted date as dd/mm/yyyy
  };

  // Check if data is available
  if (!quizData || !userDetails || !questions.length) {
    return <div>
      <div className="container mt-4" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
        <div className="text-center mb-4">
          <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" />
          <h2 className="mt-5"> Training Statement </h2>

          <h2 className="mt-5">Course: <u>{quizData.trainingName} </u></h2>
        </div>

        <p className="mt-5 ">
          I certify that I was present and successfully completed Bee’s Care Ltd.’s <b>{trainingName} Course.</b>
        </p>

        <div className="mb-3">
          <label><strong>Name of Learner:</strong></label>
          <input
            type="text"
            value={userDetails?.firstName + " " + userDetails.lastName || "Loading..."} // Using optional chaining
            className="form-control"
            readOnly
          />
        </div>

        <div className="mb-3">
          <label><strong>Organisation:</strong></label>
          <input
            type="text"
            value="Bee's Care Ltd" // Assuming the organization is static
            className="form-control"
            readOnly
          />
        </div>

        <div className="mb-3">
          <label><strong>Course Date:</strong></label>
          <input
            type="text"
            value={formatDate(quizData?.completedAt)} // Using optional chaining
            className="form-control"
            readOnly
          />
        </div>

        <p className="mt-5 ">
          <b>Candidate Signature</b>
        </p>
        <img className="mb-5" src={quizData.signature} alt="Signature" style={{ maxWidth: "300px", maxHeight: "150px" }} />
        

        <div className="text-center mt-5">
          <p><strong>© 2025 Bee’s Care Ltd. All rights reserved.</strong></p>
        </div>

      </div>
    </div>;
  }

  const handlePrint = () => {
    window.print(); // This triggers the browser's print dialog
  };

  return (
    <div className="container mt-4" style={{ fontFamily: "Arial, sans-serif", maxWidth: "800px" }}>
      <div className="text-center mb-4">
        <img className="logo-img bee" src={logo} alt="Bee's Care Ltd" /> <span className="x-sym">X</span>
        <img className="logo-img trainer" src={trainer} alt="Bee's Care Ltd" />

        <h2 className="mt-5">{quizData.trainingName} Results</h2>
      </div>

      {/* User's details */}
      <div className="mb-3">
        <label><strong>Name of Learner:</strong></label>
        <input
          type="text"
          value={userDetails?.firstName + " " + userDetails.lastName || "Loading..."} // Using optional chaining
          className="form-control"
          readOnly
        />
      </div>

      <div className="mb-3">
        <label><strong>Organisation:</strong></label>
        <input
          type="text"
          value="Bee's Care Ltd" // Assuming the organization is static
          className="form-control"
          readOnly
        />
      </div>

      <div className="mb-3">
        <label><strong>Course Date:</strong></label>
        <input
          type="text"
          value={formatDate(quizData?.completedAt)} // Using optional chaining
          className="form-control"
          readOnly
        />
      </div>

      <p className="text-center imp">
        <span className="imp-text">IMPORTANT:</span> Learners need to get at least 75% correct (15 correct answers) to gain their certificate.
      </p>

      {/* Results and answers */}
      <div className=" mt-3">
        <div className="-body">

          <h3>Your Score: {quizData?.score} / {questions.length}</h3>
          <p>Required Score for Passing: 15 / 20</p>

          {/* Displaying questions and answers */}
          <div className="questions-data mt-4">
            {questions.map((question, index) => (
              <div key={question.id} className={`question-container ${trainingType === "true_false" ? "true-false-class" : "mcqs-class"
                }`}>
                {/* Render header for non-True/False questions */}
                {trainingType !== "true_false" && (
                  <div className="row">
                    <div className="col-8">
                      <p><strong>{question.text}</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Your Answer</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Correct Answer</strong></p>
                    </div>
                  </div>
                )}

                {/* Render header for True/False questions only once */}
                {trainingType === "true_false" && index === 0 && (
                  <div className="row">
                    <div className="col-8">
                      <p><strong>Statement</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Your Answer</strong></p>
                    </div>
                    <div className="col-2 text-center">
                      <p><strong>Correct Answer</strong></p>
                    </div>
                  </div>
                )}




                {trainingType === "true_false" && (
                  <div className="row">
                    {/* Question Text */}
                    <div
                      className={`col-8 ${quizData?.answers?.[question?.id] !== question.answer ? "text-danger" : ""
                        }`}
                    >
                      {question.text}
                    </div>

                    {/* Your Answer */}
                    <div className="col-2 text-center">
                      {quizData?.answers?.[question?.id] === true || quizData?.answers?.[question?.id] === false ? (
                        <span
                          className={
                            quizData?.answers?.[question?.id] === question.answer
                              ? "text-success" // Match: Green
                              : "text-danger" // Mismatch: Red
                          }
                        >
                          {quizData?.answers?.[question?.id] ? "True" : "False"}
                        </span>
                      ) : (
                        "Not answered"
                      )}
                    </div>

                    {/* Correct Answer */}
                    <div className="col-2 text-center">
                      <span className="text-success">
                        {question.answer ? "True" : "False"}
                      </span>
                    </div>
                  </div>
                )}


                {/* Render Multiple Choice Question if not True/False */}
                {trainingType !== "true_false" && question.options && question.options.length > 0 &&
                  question.options.map((option, optionIndex) => {
                    const isUserAnswer = quizData?.answers?.[question.id] === optionIndex;
                    const isCorrectAnswer = question.correctOption === optionIndex;

                    return (
                      <div key={optionIndex} className="row">
                        <div className={`col-8 ${isUserAnswer && !isCorrectAnswer ? 'text-danger' : ''}`}>
                          <p>{optionIndex + 1}. {option}</p>
                        </div>
                        <div className="col-2 text-center">
                          {isUserAnswer ? (
                            <span className={isCorrectAnswer ? "text-success" : "text-danger"}>X</span>
                          ) : ""}
                        </div>
                        <div className="col-2 text-center">
                          {isCorrectAnswer ? (
                            <span className="text-success">X</span>
                          ) : ""}
                        </div>
                      </div>
                    );
                  })
                }





              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-3 learner-sign">
        <label><strong>Signature By Learner:</strong></label>
        <div>
          <img
            src={quizData?.signature || trainer} // Default to trainer logo if signature is missing
            alt="User Signature"
            style={{ width: "300px", height: "143px", border: "1px solid #ccc" }}
          />
        </div>
      </div>

      <div className="mt-3 trainer-sign">
        <label><strong>Signature By Trainer:</strong></label>
        <div>
          <img
            src={bismillah} // Default to trainer logo if signature is missing
            alt="User Signature"
            style={{ width: "300px", height: "143px", border: "1px solid #ccc" }}
          />
        </div>
      </div>

      <ToastContainer />

      <div className="text-center mt-4">
        <p><strong>© Trainer Courses Ltd</strong></p>
      </div>


      {/* <div className="text-center mt-4">
        <button onClick={handlePrint} className="btn btn-primary">Print Results</button>
      </div> */}

    </div>
  );
};

export default ViewTrainingResults;

